import { Unit } from '../Types/unit';

export function getUnitLevelLabel(units: Pick<Unit, 'UnitTypeId' | 'UnitTypeName' | 'UnitType'>[], fallback: string): string {
	if (!units.length || new Set(units.map((unit) => unit.UnitTypeId)).size !== 1) return fallback;
	const names = new Set(units.map((unit) => unit.UnitTypeName?.trim() || unit.UnitType?.Name?.trim()).filter(Boolean));
	return names.size === 1 ? Array.from(names)[0]! : fallback;
}
